import {api} from './apiBase';

const url = '/DividendCalendar';

export function getDividendCalendarApi(accessToken, year) {
  api.headers.Authorization = `Bearer ${accessToken}`;

  return api.get(`${url}?year=${year}`);
}
